/* LoginPage */
export const LOGIN_PAGE_SHOW_LOGIN_FORM = 'LOGIN_PAGE_SHOW_LOGIN_FORM';
export const RESET_LOGIN_PAGE = 'RESET_LOGIN_PAGE';
export const RESET_LOCAL_STORAGE = 'RESET_LOCAL_STORAGE';
export const RESET_LOGIN_PAGE_META = 'RESET_LOGIN_PAGE_META';
export const UPDATE_LOGIN_PAGE_FORM_FIELD = 'UPDATE_LOGIN_PAGE_FORM_FIELD';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

/* Booking Applications List Page */
export const GET_APPLICATIONS_REQUEST = 'GET_APPLICATIONS_REQUEST';
export const GET_APPLICATIONS_ERROR = 'GET_APPLICATIONS_ERROR';
export const GET_APPLICATIONS_SUCCESS = 'GET_APPLICATIONS_SUCCESS';

export const RESET_APPLICATIONS_META = 'RESET_APPLICATIONS_META';
export const RESET_APPLICATIONS_PAGE = 'RESET_APPLICATIONS_PAGE';

/* Booking Guidelines Page */
export const GET_BOOKING_GUIDELINES_REQUEST = 'GET_BOOKING_GUIDELINES_REQUEST';
export const GET_BOOKING_GUIDELINES_ERROR = 'GET_BOOKING_GUIDELINES_ERROR';
export const GET_BOOKING_GUIDELINES_SUCCESS = 'GET_BOOKING_GUIDELINES_SUCCESS';

export const SUBMIT_START_APPLICATION_REQUEST = 'SUBMIT_START_APPLICATION_REQUEST';
export const SUBMIT_START_APPLICATION_ERROR = 'SUBMIT_START_APPLICATION_ERROR';
export const SUBMIT_START_APPLICATION_SUCCESS = 'SUBMIT_START_APPLICATION_SUCCESS';

export const RESET_BOOKING_GUIDELINES_META = 'RESET_BOOKING_GUIDELINES_META';
export const RESET_BOOKING_GUIDELINES_PAGE = 'RESET_BOOKING_GUIDELINES_PAGE';

/* Booking Application */
export const GET_APPLICATION_BY_ID_REQUEST = 'GET_APPLICATION_BY_ID_REQUEST';
export const GET_APPLICATION_BY_ID_ERROR = 'GET_APPLICATION_BY_ID_ERROR';
export const GET_APPLICATION_BY_ID_SUCCESS = 'GET_APPLICATION_BY_ID_SUCCESS';

export const GET_APPLICATION_HKUST_POINTS_REQUEST = 'GET_APPLICATION_HKUST_POINTS_REQUEST';
export const GET_APPLICATION_HKUST_POINTS_SUCCESS = 'GET_APPLICATION_HKUST_POINTS_SUCCESS';
export const GET_APPLICATION_HKUST_POINTS_ERROR = 'GET_APPLICATION_HKUST_POINTS_ERROR';

export const GET_APPLICATION_FAVORITE_DESTINATIONS_REQUEST = 'GET_APPLICATION_FAVORITE_DESTINATIONS_REQUEST';
export const GET_APPLICATION_FAVORITE_DESTINATIONS_SUCCESS = 'GET_APPLICATION_FAVORITE_DESTINATIONS_SUCCESS';
export const GET_APPLICATION_FAVORITE_DESTINATIONS_ERROR = 'GET_APPLICATION_FAVORITE_DESTINATIONS_ERROR';

export const SUBMIT_APPLICATION_REQUEST = 'SUBMIT_APPLICATION_REQUEST';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';
export const SUBMIT_APPLICATION_ERROR = 'SUBMIT_APPLICATION_ERROR';

export const SUBMIT_INSTANT_BOOKING_REQUEST = 'SUBMIT_INSTANT_BOOKING_REQUEST';
export const SUBMIT_INSTANT_BOOKING_SUCCESS = 'SUBMIT_INSTANT_BOOKING_SUCCESS';
export const SUBMIT_INSTANT_BOOKING_ERROR = 'SUBMIT_INSTANT_BOOKING_ERROR';

export const UPDATE_APPLICATION_STATUS_REQUEST = 'UPDATE_APPLICATION_STATUS_REQUEST';
export const UPDATE_APPLICATION_STATUS_SUCCESS = 'UPDATE_APPLICATION_STATUS_SUCCESS';
export const UPDATE_APPLICATION_STATUS_ERROR = 'UPDATE_APPLICATION_STATUS_ERROR';

export const CANCEL_ALL_TRIPS_REQUEST = 'CANCEL_ALL_TRIPS_REQUEST';
export const CANCEL_ALL_TRIPS_ERROR = 'CANCEL_ALL_TRIPS_ERROR';
export const CANCEL_ALL_TRIPS_SUCCESS = 'CANCEL_ALL_TRIPS_SUCCESS';

export const RESET_APPLICATION_META = 'RESET_APPLICATION_META';
export const RESET_APPLICATION_PAGE = 'RESET_APPLICATION_PAGE';

export const GET_FAVORITE_DESTINATIONS_REQUEST = 'GET_FAVORITE_DESTINATIONS_REQUEST';
export const GET_FAVORITE_DESTINATIONS_SUCCESS = 'GET_FAVORITE_DESTINATIONS_SUCCESS';
export const GET_FAVORITE_DESTINATIONS_ERROR = 'GET_FAVORITE_DESTINATIONS_ERROR';

export const GET_APPLICATION_STAFFS_REQUEST = 'GET_APPLICATION_STAFFS_REQUEST';
export const GET_APPLICATION_STAFFS_SUCCESS = 'GET_APPLICATION_STAFFS_SUCCESS';
export const GET_APPLICATION_STAFFS_ERROR = 'GET_APPLICATION_STAFFS_ERROR';

export const SUBMIT_APPLICATION_FAVORITE_DESTINATION_REQUEST = 'SUBMIT_APPLICATION_FAVORITE_DESTINATION_REQUEST';
export const SUBMIT_APPLICATION_FAVORITE_DESTINATION_SUCCESS = 'SUBMIT_APPLICATION_FAVORITE_DESTINATION_SUCCESS';
export const SUBMIT_APPLICATION_FAVORITE_DESTINATION_ERROR = 'SUBMIT_APPLICATION_FAVORITE_DESTINATION_ERROR';

export const SUBMIT_FAVORITE_DESTINATION_REQUEST = 'SUBMIT_FAVORITE_DESTINATION_REQUEST';
export const SUBMIT_FAVORITE_DESTINATION_SUCCESS = 'SUBMIT_FAVORITE_DESTINATION_SUCCESS';
export const SUBMIT_FAVORITE_DESTINATION_ERROR = 'SUBMIT_FAVORITE_DESTINATION_ERROR';

export const DELETE_FAVORITE_DESTINATION_BY_ID_REQUEST = 'DELETE_FAVORITE_DESTINATION_BY_ID_REQUEST';
export const DELETE_FAVORITE_DESTINATION_BY_ID_SUCCESS = 'DELETE_FAVORITE_DESTINATION_BY_ID_SUCCESS';
export const DELETE_FAVORITE_DESTINATION_BY_ID_ERROR = 'DELETE_FAVORITE_DESTINATION_BY_ID_ERROR';

export const RESET_FAVORITE_DESTIONATION_META = 'RESET_FAVORITE_DESTIONATION_META';
export const RESET_FAVORITE_DESTIONATION_PAGE = 'RESET_FAVORITE_DESTIONATION_PAGE';

// Application Previous Bookings
export const GET_APPLICATION_PREVIOUS_BOOKINGS_REQUEST = 'GET_APPLICATION_PREVIOUS_BOOKINGS_REQUEST';
export const GET_APPLICATION_PREVIOUS_BOOKINGS_SUCCESS = 'GET_APPLICATION_PREVIOUS_BOOKINGS_SUCCESS';
export const GET_APPLICATION_PREVIOUS_BOOKINGS_ERROR = 'GET_APPLICATION_PREVIOUS_BOOKINGS_ERROR';
